import * as React from "react";
import Show from "../../../v2/FormRegistration/components/Show";
import { func } from "../../../../utils";

export interface MatchGoalProps {
  player_name: string;
  club_name: string;
  home_away: "home" | "away";
  time_minute: number;
  owngoal_status: number;
  penalty_status: number;
  assist_name: string;
}

export interface NewMatchGoalProps {
  id: number;
  player_name: string;
  player_id: number;
  team_type: "home" | "away";
  school_id: number;
  minute: number;
  is_own_goal: number;
  is_penalty: number;
}

export interface MatchCardProps {
  id: number;
  player_name: string;
  player_id: number;
  team_type: "home" | "away";
  school_id: number;
  card_type: "yellow" | "red";
  minute: number;
  is_own_goal: number;
}

export interface ScoreItemProps {
  item: NewMatchGoalProps | MatchCardProps;
  textAlign: "left" | "right";
  isAway: boolean;
}

const ScoreItem: React.FC<ScoreItemProps> = ({ item, textAlign = "left", isAway = false }) => {
  const goalScorerName = item?.player_name;
  const isOwnGoal = Boolean(item?.is_own_goal);
  // @ts-ignore
  const isPenalty = Boolean(item?.is_penalty);

  const minutesTime = `${item?.minute || 0}'`;

  const handleGoalDescription = React.useCallback(() => {
    return <span className="">{goalScorerName ?? "-"}</span>;
  }, [goalScorerName]);

  const goalNameElement = handleGoalDescription();

  const renderContent = () => {
    // @ts-ignore
    const isCards = Boolean(item?.card_type);

    if (isCards) {
      // @ts-ignore
      if (item?.card_type === "red") {
        return (
          <p
            style={{ textAlign: textAlign }}
            className={`text-[12px] leading-[12px] text-white capitalize flex ${
              isAway ? "flex-row-reverse" : "flex-row"
            } gap-x-2 items-center w-full`}
          >
            <img
              src={func.getStaticImg("/illustration/red-card.svg")}
              alt="red-card"
              className="relative flex-shrink-0 h-[12px] w-[12px]"
            />
            <span className="leading-[14px] relative top-[0.5px]">
              {goalScorerName} {minutesTime}
            </span>
          </p>
        );
      }

      return (
        <p
          style={{ textAlign: textAlign }}
          className={`text-[12px] leading-[12px] text-white capitalize flex ${
            isAway ? "flex-row-reverse" : "flex-row"
          } gap-x-4 items-center w-full`}
        >
          <img
            src={func.getStaticImg("/illustration/yellow-card.svg")}
            alt="yellow-card"
            className="object-fit h-[12px] w-[12px] flex-shrink-0"
          />
          <span className="leading-[14px] relative top-[0.5px]">
            {goalScorerName} {minutesTime}
          </span>
        </p>
      );
    }

    return (
      <p
        style={{ textAlign: textAlign }}
        className={`text-[12px] leading-[12px] text-white capitalize flex ${
          isAway ? "flex-row-reverse" : "flex-row"
        } gap-x-2 items-center w-full`}
      >
        <img
          src={func.getStaticImg("/illustration/ball.svg")}
          alt="ball"
          className="object-fit h-[12px] w-[12px]"
        />
        <span className="leading-[14px] relative top-[0.5px]">
          {goalScorerName} {minutesTime}
          {isOwnGoal && <b className="pl-1">(OG)</b>}
          {/* normal-case: baris ini `capitalize`, tanpa ini tampilnya jadi "(P)". */}
          {isPenalty && <b className="pl-1 normal-case">(p)</b>}
        </span>
      </p>
    );
  };

  return <div className="flex flex-col w-full">{renderContent()}</div>;
};

export interface ScoreBoardProps {
  data: NewMatchGoalProps[];
  cards: MatchCardProps[];
}

const ScoreBoard: React.FC<ScoreBoardProps> = ({ data, cards }) => {
  const homeGoal = [...data]?.filter((val) => val?.team_type === "home");
  const homeCards = [...cards]?.filter((val) => val?.team_type === "home");
  const dataHome = [...homeGoal, ...homeCards]?.sort((a, b) => a?.minute - b?.minute);

  const awayGoal = [...data]?.filter((val) => val?.team_type === "away");
  const awayCards = [...cards]?.filter((val) => val?.team_type === "away");
  const dataAway = [...awayGoal, ...awayCards]?.sort((a, b) => a?.minute - b?.minute);

  return (
    <div className="flex justify-between bg-[#354D69] p-[16px] rounded-[8px] max-w-[708px] mx-auto">
      <div className="flex flex-col items-start gap-y-[12px] w-[48%]">
        {dataHome?.map((data, idx) => (
          <ScoreItem textAlign="left" item={data} key={idx} isAway={false} />
        ))}
      </div>
      <div className="flex flex-col items-end gap-y-[12px] w-[48%]">
        {dataAway?.map((data, idx) => (
          <ScoreItem textAlign="right" item={data} key={idx} isAway />
        ))}
      </div>
    </div>
  );
};

export default ScoreBoard;
